// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable @typescript-eslint/naming-convention */
export enum SellerRegionEnum {
  UNSPECIFIED = '',
  CN = 'CN',
  HK = 'HK',
  GB = 'GB',
  ID = 'ID',
  TH = 'TH',
  MY = 'MY',
  VN = 'VN',
  IT = 'IT',
  TR = 'TR',
  PH = 'PH',
  MO = 'MO',
  TW = 'TW',
  SG = 'SG',
  US = 'US',
  ES = 'ES',
  IE = 'IE',
  BR = 'BR',
}

export enum PartnerRegion {
  PartnerRegion_UNSPECIFIED = 0,
  PartnerRegion_CN = 1,
  PartnerRegion_HK = 2,
  PartnerRegion_GB = 3,
  PartnerRegion_ID = 4,
  PartnerRegion_TH = 5,
  PartnerRegion_MY = 6,
  PartnerRegion_VN = 7,
  PartnerRegion_IT = 8,
  PartnerRegion_TR = 9,
  PartnerRegion_PH = 10,
  PartnerRegion_MO = 11,
  PartnerRegion_TW = 12,
  PartnerRegion_SG = 13,
  PartnerRegion_ES = 14,
  PartnerRegion_IE = 15,
  PartnerRegion_BR = 16,
  PartnerRegion_US = 100,
}

export const PARTNER_REGION_MAP: Record<PartnerRegion, SellerRegionEnum> = {
  [PartnerRegion.PartnerRegion_GB]: SellerRegionEnum.GB,
  [PartnerRegion.PartnerRegion_UNSPECIFIED]: SellerRegionEnum.UNSPECIFIED,
  [PartnerRegion.PartnerRegion_HK]: SellerRegionEnum.HK,
  [PartnerRegion.PartnerRegion_ID]: SellerRegionEnum.ID,
  [PartnerRegion.PartnerRegion_IT]: SellerRegionEnum.IT,
  [PartnerRegion.PartnerRegion_MO]: SellerRegionEnum.MO,
  [PartnerRegion.PartnerRegion_MY]: SellerRegionEnum.MY,
  [PartnerRegion.PartnerRegion_TH]: SellerRegionEnum.TH,
  [PartnerRegion.PartnerRegion_VN]: SellerRegionEnum.VN,
  [PartnerRegion.PartnerRegion_PH]: SellerRegionEnum.PH,
  [PartnerRegion.PartnerRegion_TW]: SellerRegionEnum.TW,
  [PartnerRegion.PartnerRegion_SG]: SellerRegionEnum.SG,
  [PartnerRegion.PartnerRegion_CN]: SellerRegionEnum.CN,
  [PartnerRegion.PartnerRegion_TR]: SellerRegionEnum.TR,
  [PartnerRegion.PartnerRegion_US]: SellerRegionEnum.US,
  [PartnerRegion.PartnerRegion_ES]: SellerRegionEnum.ES,
  [PartnerRegion.PartnerRegion_IE]: SellerRegionEnum.IE,
  [PartnerRegion.PartnerRegion_BR]: SellerRegionEnum.BR,
};

export const SUFFIX_CHECK_ALLOWLIST = [
  'affiliate_target_invitation_list_search_product',
  'affiliate_crm_creator_detail_list_product',
  'plan_public_list_page_search_product',
  'affiliate_plan_title',
  'datacompass_creator_analysis_title',
  'affiliate_seller_contact_info_set_up_popup_description',
  'affiliate_seller_contact_info_set_up_popup_switch_description',
  'affiliate_seller_contact_info_set_up_popup_switch_title',
];
